/**
 * @name Integration
 * @description
 *
 * Servicio para el reporte  de Simulacion Academica Schedule
 */
    class tablesintServices {

     constructor($resource,SERVICE_URL_CONSTANT){

         var services = $resource(SERVICE_URL_CONSTANT.tablesintFiltering  +'/:folder/:controller',{},{
             getTabla :{
               method:'GET',
               params : {
                folder : 'reports',
                controller: (SERVICE_URL_CONSTANT.tablesType=='PHP')?'tablas.php':'integration'
               }
             },

         });


          return {
             services:services
         }

    }
}

tablesintServices.$inject = ['$resource','SERVICE_URL_CONSTANT']

  export default angular.module('services.tablesintServices', [])
  .service('tablesintServices', tablesintServices)
  .name;


// WEBPACK FOOTER //
// ./src/app/integration-front/tablesint/tablesintServices.js